import { IColumns } from '../../../../components/Table'

export type PairsColumnsType = 'checkbox' | 'id' | 'label' | 'clientTypes' | 'updatedAt' | 'actions'

export const columns: IColumns<PairsColumnsType>[] = [
  {
    id: 'checkbox',
    label: '',
  },
  {
    id: 'id',
    label: 'ID',
  },
  {
    id: 'label',
    label: 'INSTRUMENT',
  },
  {
    id: 'clientTypes',
    label: 'P | I | T',
    format: (value) => (value ? `${value}%` : '-'),
  },
  {
    id: 'updatedAt',
    label: 'LAST SYNCED',
    format: (value) =>
      value
        ? new Date(value as Date).toLocaleString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
        : '-',
  },
  {
    id: 'actions',
    label: 'ACTIONS',
  },
]
